const allowedKeys = ['c', 'v', 'a'];

export const CharacterConfig = {
  allowedKeys,
};
